import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-news-readmore-info',
  templateUrl: './news-readmore-info.component.html',
  styleUrls: ['./news-readmore-info.component.scss'],
})
export class NewsReadmoreInfoComponent implements OnInit {

  @Input() value: any;

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() {
    //console.log("value,,,,", this.value)
    document.getElementById("contentValue").innerHTML= this.value.content;
  }

  dismiss() {
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }


}
